module.exports = __webpack_public_path__ + "img/three.675c453f.svg";